export default __webpack_public_path__ + "static/media/TriangleParkingHomepage.2461b978.png";